// Cross-scene game state. Phaser scenes can read/write this directly.

import type { GameParams } from '../params';

export interface RunState {
  params: GameParams;
  startTimeMs: number;
  endTimeMs: number;
  totalAssets: number;
  patchedCount: number;
  notExploitableCount: number;
  health: number;
  cveHits: number;
  reachedBoss: boolean;
  outcome: 'win-then-boss' | 'boss-win' | 'health' | 'timeout' | 'pending';
}

export const createRunState = (params: GameParams, totalAssets: number, healthSegments: number): RunState => ({
  params,
  startTimeMs: 0,
  endTimeMs: 0,
  totalAssets,
  patchedCount: 0,
  notExploitableCount: 0,
  health: healthSegments,
  cveHits: 0,
  reachedBoss: false,
  outcome: 'pending',
});

export const elapsedSeconds = (s: RunState): number => {
  if (!s.startTimeMs) return 0;
  const end = s.endTimeMs || performance.now();
  return Math.max(0, Math.round((end - s.startTimeMs) / 1000));
};
